import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ShieldCheck, AlertTriangle } from "lucide-react";
import { CATEGORIES, CATEGORY_INFO } from "../../lib/categories";

export default function Footer() {
  return (
    <footer className="bg-[var(--navy)] text-slate-200 mt-16" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 py-12 grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
        <div>
          <p className="font-display font-extrabold text-2xl text-white">99Bazaar <span className="text-[var(--orange)]">Maharashtra</span></p>
          <p className="mt-3 text-sm text-slate-300 leading-relaxed">महाराष्ट्राचा स्वतःचा ऑनलाइन बाजार. Buy & sell anything across all 36 districts — no broker, no commission.</p>
        </div>
        <div>
          <p className="font-semibold text-white mb-3">Categories</p>
          <ul className="grid grid-cols-2 gap-1.5 text-sm">
            {CATEGORIES.map((c) => (
              <li key={c}><Link to={`/buy?category=${c}`} className="hover:text-[var(--orange)] transition-colors" data-testid={`footer-cat-${c.toLowerCase()}`}>{c} · {CATEGORY_INFO[c].mr}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <p className="font-semibold text-white mb-3">Safety Tips · सुरक्षितता</p>
          <ul className="space-y-2 text-sm text-slate-300">
            <li className="flex gap-2"><ShieldCheck className="w-4 h-4 mt-0.5 text-[var(--orange)] shrink-0" /> वस्तू पाहूनच पैसे द्या</li>
            <li className="flex gap-2"><ShieldCheck className="w-4 h-4 mt-0.5 text-[var(--orange)] shrink-0" /> Meet in a public place</li>
            <li className="flex gap-2"><ShieldCheck className="w-4 h-4 mt-0.5 text-[var(--orange)] shrink-0" /> Never share OTP</li>
            <li className="flex gap-2"><ShieldCheck className="w-4 h-4 mt-0.5 text-[var(--orange)] shrink-0" /> आगाऊ पैसे / Advance देऊ नका</li>
            <li className="flex gap-2"><ShieldCheck className="w-4 h-4 mt-0.5 text-[var(--orange)] shrink-0" /> गाडी/प्रॉपर्टीची कागदपत्रे तपासा</li>
          </ul>
        </div>
        <div>
          <p className="font-semibold text-white mb-3">Contact · संपर्क</p>
          <ul className="space-y-2 text-sm">
            <li className="flex gap-2"><Phone className="w-4 h-4 text-[var(--orange)]" /> <a href="tel:+919999999999" data-testid="footer-phone">+91 99999 99999</a></li>
            <li className="flex gap-2"><Mail className="w-4 h-4 text-[var(--orange)]" /> <a href="mailto:support@99bazaar.com" data-testid="footer-email">support@99bazaar.com</a></li>
            <li className="flex gap-2"><MapPin className="w-4 h-4 text-[var(--orange)] shrink-0 mt-0.5" /> <span data-testid="footer-address">99Bazaar Maharashtra, Pune, Maharashtra - 411001</span></li>
            <li><Link to="/plans" className="text-[var(--orange)] font-semibold hover:underline" data-testid="footer-plans-link">Membership Plans →</Link></li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 pb-8">
        <div className="rounded-xl bg-white/5 border border-white/10 p-4 flex gap-3 text-sm" data-testid="footer-disclaimer">
          <AlertTriangle className="w-5 h-5 text-[var(--orange)] shrink-0" />
          <p><b className="text-white">Disclaimer:</b> 99Bazaar हा फक्त जाहिरात प्लॅटफॉर्म आहे. व्यवहाराची जबाबदारी आमची नाही. कृपया काळजी घ्या. <span className="text-slate-400">Buyers and sellers deal directly; 99Bazaar is not responsible for any transaction.</span></p>
        </div>
      </div>
      <div className="border-t border-white/10 py-4 text-center text-xs text-slate-400">
        © {new Date().getFullYear()} 99bazaarmaharashtra.com · All rights reserved · <Link to="/privacy" className="hover:text-white" data-testid="footer-privacy-link">Privacy Policy</Link> · <Link to="/terms" className="hover:text-white" data-testid="footer-terms-link">Terms</Link> · <a href="mailto:contact@99bazaarmaharashtra.com" className="hover:text-white" data-testid="footer-contact-email">contact@99bazaarmaharashtra.com</a> · <Link to="/admin" className="hover:text-white" data-testid="footer-admin-link">Admin</Link>
      </div>
    </footer>
  );
}
